module.exports = __webpack_public_path__ + "img/undraw_sync_re_492g.258ef448.svg";